export default {"src":"/_next/static/media/on-boarding-step-two-image.8c2a5429.svg","height":152,"width":251,"blurWidth":0,"blurHeight":0};